const CustomerJourneyType = {
  BUNDLED_CONSENT_NO_MATCHING: 'BUNDLED_CONSENT_NO_MATCHING',
  BUNDLED_CONSENT_WITH_DESELECTIONS: 'BUNDLED_CONSENT_WITH_DESELECTIONS',
  PREDEFINED_SUPPLIER: 'PREDEFINED_SUPPLIER',
  SELECT_AND_CONNECT: 'SELECT_AND_CONNECT',
};

export default CustomerJourneyType;
